import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=9f3b768e"
import script from "./AddressForm.vue?vue&type=script&lang=ts"
export * from "./AddressForm.vue?vue&type=script&lang=ts"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=9f3b768e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports